import { parseISO } from 'date-fns';
import { minTwoDigits } from '..';

const GenerateDrivingLicenceNumber = (lastName: string, dob: string, title: string) => {
	if (typeof lastName !== 'string' || typeof title !== 'string') {
		throw new Error('Invalid input');
	}
	const tempDate = parseISO(dob);
	if (isNaN(tempDate.getTime())) {
		throw new Error('Invalid Date');
	}
	// Convert last name to upper case, remove spaces and ensure it has 5 characters
	const firstFive = lastName.replace(/\s/g, '').toUpperCase().padEnd(5, '9').substring(0, 5);

	// Extract year, month and day from date of birth
	const year = tempDate.getFullYear().toString();
	const month = minTwoDigits(tempDate.getMonth() + 1);
	const day = minTwoDigits(tempDate.getDate());

	// Adjust month for female
	let adjustedMonth = month;
	if (title !== '003') {
		// Female
		adjustedMonth = `${parseInt(month[0], 10) + 5}${month[1]}`;
	}

	// Construct parts of driving license number
	const partOne = firstFive;
	const partTwo = `${year[2]}${adjustedMonth}${day}${year[3]}`;

	return { partOne, partTwo };
};

export default GenerateDrivingLicenceNumber;
